import type { FaireProductEntity } from "../../entity_types/product";

export const p_keudjdmntd: FaireProductEntity = {
  token: "p_keudjdmntd",
  type: "product",
  name: "Short Sleeve Floral Pattern V-Neck Dress",
  brandToken: "b_3l4cxzzyla",
  brandName: "THML",
  imageUrl:
    "https://cdn.faire.com/fastly/80782bc0cc0f018c2f3782489ed81343539c5a5969c33e207bdc76d320c1d604.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d22557e4d8c40f36ace8256bf92361db725e728ab5aa6ffa205a0f12b359a93c.jpeg",
    "https://cdn.faire.com/fastly/559b64c4a032725465510a3ef3c037bd32c3d0ec317495bd1439a24c8b6c3887.jpeg",
    "https://cdn.faire.com/fastly/88fdb445b47f29bfa4dff875be8280acf887ea755acf9b02e7eec73b2c11d25b.jpeg",
    "https://cdn.faire.com/fastly/b9c757a604684e9c1e564741199c54d6a92849abe07d13d353bc6ec55ac50554.jpeg",
    "https://cdn.faire.com/fastly/0de70c121c290e0ab46dd004f81d03e4678b0fd09358e89b7781de8a9933545c.jpeg",
    "https://cdn.faire.com/fastly/baef2ee82f42bcbd50009b7bdc9cc9f93fa80112f989160320be9228e22f49fd.jpeg",
    "https://cdn.faire.com/fastly/546b27bd2ee25f17d5d7ee40610584785766e052d6c03380ea79c00c04384ad2.jpeg",
    "https://cdn.faire.com/fastly/ad93b7a16dfaeff91e1860504c7e7da28fce28a7c7e9f5f6204f893b186d38ae.jpeg",
    "https://cdn.faire.com/fastly/a9bc66352e9992e074a74d783fe036e6ad7443dac13a87df3fde393b2708db87.jpeg",
    "https://cdn.faire.com/fastly/20e2faaacbc21dac73bf51dbe14a1e95d369ac21de3badd0daeb5505ccc03cd3.jpeg",
    "https://cdn.faire.com/fastly/569f842d69ef221b43c6e30f757348be7b81ff16c83f8c0a50844e449503ef13.jpeg",
    "https://cdn.faire.com/fastly/adadcb7dcfd9b859c35f7e0d517b57d625bd778b2e45f514d6d76a46346a0ee6.jpeg",
    "https://cdn.faire.com/fastly/4a4b656d8c18cec36cb64fed856c83b04adc9543d4318304d1e4f81bd73708c9.jpeg",
  ],
  priceDollars: 41.4,
  description:
    'Short Sleeve Floral Pattern V-Neck Dress\r\n.\r\n/ Style Measurements for Size S\r\n/ Designed in USA\r\n - Body Length: 34 1/2 in\r\n - Bust Width: 42 in\r\n - Sleeve Length: 10 in\r\n.\r\n/ Model Sizes\r\n - Wearing Size S\r\n - Height 5\' 9", Bust 32", Waist 25 1/2", Hips 36"\r\n.\r\n/ Prepack Contents\r\n - In a Pack of XS(1), S(2), M(2), and L(1) per Color Only\r\n.\r\n/ Fabric Content\r\n - WOVEN / 100% Cotton',
  tags: [],
  msrpDollars: 82.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T20:19:18.116Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
